import { render, staticRenderFns } from "./AllCountryFarmerRegion.vue?vue&type=template&id=85f9b7ba&scoped=true&"
import script from "./AllCountryFarmerRegion.vue?vue&type=script&lang=js&"
export * from "./AllCountryFarmerRegion.vue?vue&type=script&lang=js&"
import style0 from "./AllCountryFarmerRegion.vue?vue&type=style&index=0&id=85f9b7ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f9b7ba",
  null
  
)

export default component.exports